import React from "react"
import PropTypes from "prop-types"
import { ResponsiveBar } from '@nivo/bar'
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

export default function HorizontalBarChart(props) {
  const chartData = []
  const breakpoints = useBreakpoint();
  const fillSettings = [];
  let marginRight = 60
  let marginLeft =  200

  if (props.uses_legend){
    marginRight = 130
  }

  if (breakpoints.sm){
    marginRight = 10
    marginLeft = 90
  }

  props.xmlChildren.map(child => chartData.push({id: child.content, value: Number(child.attributes.total)}))
  // Add up all values to get total
  const total = chartData.map(datum => datum.value).reduce((total, current) => total + current, 0)

  const legendSettings = [{
    dataFrom: 'indexes',
    anchor: 'bottom-right',
    direction: 'column',
    justify: false,
    translateX: 120,
    translateY: 0,
    itemsSpacing: 2,
    itemWidth: 100,
    itemHeight: 20,
    itemDirection: 'left-to-right',
    itemOpacity: 0.85,
    symbolSize: 20,
    effects: [
      {
        on: 'hover',
        style: {
          itemOpacity: 1
        }
      }
    ]
  }]


  for(let i = 0; i < chartData.length; i++ ){
    if(i % 4 === 0){
      fillSettings.push({
        match: {
          id: chartData[i].id
        },
        id: 'dots'
      })
    }
    else if ((i + 2) % 2 === 0 ){
      fillSettings.push({
        match: {
          id: chartData[i].id
        },
        id: 'lines'
      })
    }
  }

  function trunctateString(string) {
    const length = breakpoints.sm ? 13 : 100
    return (string.length > length) ? string.substr(0, length-1) + '...' : string
  }


  const customAxisLeft = tick => {
    const splitTickValue = tick.value.split("\\n");

    return (
      <g transform={`translate(${tick.x},${tick.y})`} style={{ opacity: 1 }}>
        <line
          x1="0"
          x2="-5"
          y1="0"
          y2="0"
          style={{
            stroke: 'rgb(119, 119, 119)',
            strokeWidth: 1,
          }}
        >
        </line>
        <text
          dominantBaseline="central"
          textAnchor="end"
          transform={`translate(${breakpoints.sm ? -10 : -20}, ${splitTickValue.length > 1 ? -24 : -16}) rotate(0)`}
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: 'sans-serif',
            fontSize: 14
          }}
        >
        { splitTickValue.map(value => {
          return (
            <>
              <title>{value}</title>
              <tspan key={value} x={tick.x} dx="0" dy="16">{trunctateString(value)}</tspan>
            </>
          )
        } ) }
        </text>
      </g>
    )

  }

  return (
    <ResponsiveBar
      data={chartData}
      margin={{ top: 50, right: marginRight, bottom: 80, left: marginLeft }}
      padding={0.3}
      // colors={props.custom_scheme}
      colors={{ scheme: 'category10' }}
      colorBy='value'
      layout="horizontal"
      defs={[
        {
          id: 'dots',
          type: 'patternDots',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          size: 4,
          padding: 1,
          stagger: true
        },
        {
          id: 'lines',
          type: 'patternLines',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          rotation: -45,
          lineWidth: 6,
          spacing: 10
        }
      ]}
      enableArea={true}
      areaOpacity={1}
      fill={fillSettings}
      borderColor={{ from: 'color' }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: breakpoints.sm ? 90 : 0,
        legend: 'Total',
        legendPosition: 'middle',
        legendOffset: 60,
        fontSize: 15,
      }}
      axisLeft={{
        renderTick: customAxisLeft,
      }}
      tooltip={d => (d.id, d.value, `Responses: ${d.value}`)}
      label={d => `${Math.round((d.value / total) * 100)}%`}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor='#ffffff'
      legends={props.uses_legend ? legendSettings : []}
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  )
}

HorizontalBarChart.propTypes = {
  xmlChildren: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  uses_legend: PropTypes.bool.isRequired,
  custom_scheme: PropTypes.array.isRequired,
}

HorizontalBarChart.defaultProps = {
  xmlChildren: [],
  question: null,
  uses_legend: false
}
